import { Flexcol } from "../../components/Flexbox"
import { Input, Typography } from 'antd'
import { useState } from "react"

const { TextArea } = Input
const { Text } = Typography

export const DeclareDataRequestInterestModal = p => {
  const { onMessage } = p
  const [interest_message, setInterestMessage] = useState('')
  const _onMessage = e => {
    onMessage(e.target.value)
    setInterestMessage(e.target.value)
  }
  return (
    <Flexcol>
      <Flexcol top='20px'/>
      <Text>
        Thank you for declaring interest in this data request. <br/>
        Please provide some details about your data availability (i.e. geographical coverage, temporal availability, cost) in order to communicate it with the interested party. <br/>
        The Mobito team will manage your request and come back to you shortly.
      </Text>
      <Flexcol top='20px'/>
      <TextArea 
        style={{ height: 200 }}
        onChange={_onMessage}
        value={interest_message}/>
    </Flexcol>
  )
}